import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const IndianCreators: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Button onClick={() => navigate('/blog')} sx={{ mb: 3, textTransform: 'none' }}>
          {t('blog.backToBlog')}
        </Button>
        <Typography variant="overline" color="primary" sx={{ fontWeight: 600 }}>
          Creators · May 2026
        </Typography>
        <Typography variant="h3" component="h1" sx={{ my: 2, fontWeight: 700 }}>
          IndeeClips for Indian Creators — Grow Your Audience
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.85 }}>
          How Indian content creators are using IndeeClips to reach new audiences and build their channels from scratch.
        </Typography>

        <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>
          Why IndeeClips for Creators?
        </Typography>
        <Box component="ul" sx={{ '& li': { mb: 1, color: 'text.secondary', lineHeight: 1.85 } }}>
          <li>50,000+ active viewers looking for quality Indian content</li>
          <li>Zero cost to upload and distribute your videos</li>
          <li>Support for all Indian languages and regional content</li>
          <li>Monetization opportunities for eligible creators</li>
          <li>Direct connection with your Indian audience</li>
          <li>Fair content distribution without algorithm bias</li>
        </Box>

        <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>
          Tips for Channel Growth
        </Typography>
        <Box component="ul" sx={{ '& li': { mb: 1, color: 'text.secondary', lineHeight: 1.85 } }}>
          <li>Upload consistently — aim for 2-3 videos per week</li>
          <li>Use compelling thumbnails and clear titles</li>
          <li>Engage with your audience in the comments section</li>
          <li>Create content in your regional language for authenticity</li>
          <li>Promote your IndeeClips channel on social media</li>
          <li>Collaborate with other Indian creators on the platform</li>
        </Box>

        <Typography variant="body1" color="text.secondary" sx={{ mt: 4, lineHeight: 1.85 }}>
          Creator support:{' '}
          <Typography
            component="a"
            href="mailto:contact@indeeclips.com"
            sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            contact@indeeclips.com
          </Typography>
        </Typography>
      </Container>
    </Box>
  );
};

export default IndianCreators;
